import queryString from 'query-string';

import { paramOrder, QueryParams } from './queryParamDeclaration';

export const generateQueryString = (params: Partial<QueryParams>) => {
	// Build a new object in the correct order, with safe fallback
	const orderedParams = paramOrder.reduce(
		(acc, key) => {
			acc[key] = params[key];
			return acc;
		},
		{} as Record<(typeof paramOrder)[number], unknown>
	);

	// Build a new search string with query-string
	return queryString.stringify(orderedParams, {
		arrayFormat: 'comma',
		skipEmptyString: true,
		skipNull: true
	});
};
